import { render } from "./DonesView.vue?vue&type=template&id=c4c8e7ac&ts=true"
import script from "./DonesView.vue?vue&type=script&lang=ts"
export * from "./DonesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__